import { Injectable } from '@angular/core';
import {  Router } from '@angular/router';
import * as firebase from 'firebase';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  constructor(private router: Router){

  }

  createUserWithEmailAndPassword=(email:string,password:string)=>{
    return firebase.auth().createUserWithEmailAndPassword(email,password);
  }
  
  signInWithEmailAndPassword = (email:string,password:string)=>{
    return firebase.auth().signInWithEmailAndPassword(email,password);
  }

  sendPasswordResetEmail = (email:string) =>{
    return firebase.auth().sendPasswordResetEmail(email,{url:environment.forgetPasswordUrl,handleCodeInApp: true});
  }

  confirmPasswordReset = (code:string,password:string) =>{
    return firebase.auth().confirmPasswordReset(code,password);
  }

  logout =() =>{
    return firebase.auth().signOut();
  }

  redirectTo: string | null = null;
  setIdToken = () =>{
    firebase.auth().onAuthStateChanged((user) =>{
      if (user) {
        user.getIdToken(true).then( (idToken) =>{
          // It shows the Firebase token now
          localStorage.setItem('matiAdminToken', idToken);
          this.router.navigateByUrl("");
          let redirectTo =''; // Default redirect
          const redirectRoute = localStorage.getItem('redirectRoute');
          if(redirectRoute && redirectRoute != undefined && redirectRoute != null){
            redirectTo =redirectRoute;
            localStorage.removeItem('redirectRoute');
          }
          this.router.navigateByUrl(redirectTo);
          //redrict after verification
        })
      }
    })
  }
  resetIdToken = () =>{
    firebase.auth().onAuthStateChanged((user) =>{
      if (user) {
        user.getIdToken(true).then( (idToken) =>{
          // It shows the Firebase token now
          localStorage.setItem('matiAdminToken', idToken);
          //redrict after verification
        })
      }
    })
  }


  
  uploadCertificateImage = async (image:any) =>{
    const storageRef = firebase.storage().ref();
    return new Promise((resolve, reject) => {
      const username = localStorage.getItem('mati_admin_username');
      let childRef = `certificates/ ${new Date().getTime()} ${username} _webimage`;
      let imagesRef = storageRef.child(childRef);
      let uploadTask = imagesRef.put(image);
      uploadTask.on('state_changed', function (snapshot) {
          let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED:
                  break;
              case firebase.storage.TaskState.RUNNING:
                  break;
          }
      }, function (error) {
          reject(error);
      }, function () {
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
              resolve(downloadURL);
          });
      });
    });
  }
}
